import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductState from "interfaces/state/ProductState";
import { getProductAsync } from "apis/ProductApi";

const initialState: ProductState = {
  loading: false,
  selectedProductId: 0,
  productWithLicenseInfo: null,
};

export const getProductDetailWithLicenseAndFeatures = createAsyncThunk(
  "product/productDetailWithLicenseAndFeature",
  async (productId: number, thunkAPI) => {
    return await getProductAsync(productId);
  }
);

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setSelectedProductId: (state, action) => {
      state.selectedProductId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getProductDetailWithLicenseAndFeatures.pending,
      (state, action) => {
        state.loading = true;
      }
    );
    builder.addCase(
      getProductDetailWithLicenseAndFeatures.fulfilled,
      (state, action) => {
        state.productWithLicenseInfo = action.payload;
        state.loading = false;
      }
    );
    builder.addCase(
      getProductDetailWithLicenseAndFeatures.rejected,
      (state, action) => {
        state.loading = false;
        state.productWithLicenseInfo = null;
      }
    );
  },
});

export const { setSelectedProductId } = productSlice.actions;
export default productSlice.reducer;
